module.exports = __webpack_public_path__ + "static/img/volleyball.ae25b8b.jpg";